export { default } from './FooterButtons';
